import { ReactComponent as SearchIcon } from 'assets/search.svg'
import AutocompleteInput from 'components/shared/textFields/AutocompleteInput'
import React, { useEffect } from 'react'
import { fetchExaminersList } from 'store/cattlesSlice'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { COLORS } from 'styles/colors'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'

type RespPersonsProps = {
	setActiveFilters: React.Dispatch<React.SetStateAction<any>>
	responsiblePersons: { ids: number[] }
}

const ResponsiblePersonsBlock = (props: RespPersonsProps) => {
	const { setActiveFilters, responsiblePersons } = props
	const dispatch = useAppDispatch()
	const { examinersList, examinersListPending, examinersListError } =
		useAppSelector(state => state.cattlesSlice)

	useEffect(() => {
		if (examinersList.length === 0) {
			dispatch(fetchExaminersList())
		}
	}, [])
	return (
		<>
			{examinersListError ? (
				<TypographyPrimary>{examinersListError}</TypographyPrimary>
			) : (
				<AutocompleteInput
					widthForInput={'100%'}
					startIcon={<SearchIcon stroke={COLORS.icon} />}
					onClick={id => {
						setActiveFilters(prev => {
							const ids = prev.responsiblePersons.ids
							const isPresent = ids.includes(id)
							const updatedIds = isPresent
								? ids.filter(item => item !== id)
								: [...ids, id]

							return {
								...prev,
								responsiblePersons: {
									...prev.responsiblePersons,
									ids: updatedIds,
								},
							}
						})
					}}
					isCheckbox
					availableList={examinersList}
					loading={examinersListPending}
					selectedValues={responsiblePersons.ids}
					label={'Исполнитель'}
					limitTags={2}
					needChip
				/>
			)}
		</>
	)
}

export default ResponsiblePersonsBlock
